
import * as React from "react"

/**
 * Detects if the current device is a mobile device based on the user agent.
 * This is more reliable than width-based detection, especially when devices
 * are rotated (landscape vs portrait).
 *
 * Detects: iPhone, iPad, iPod, Android devices, Windows Phone, BlackBerry, and Opera Mini
 */
function detectMobileDevice(): boolean {
  if (typeof navigator === 'undefined') return false

  return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)
}

export function useIsMobile() {
  const [isMobile, setIsMobile] = React.useState<boolean | undefined>(undefined)

  React.useEffect(() => {
    // Set the initial value based on user agent
    setIsMobile(detectMobileDevice())

    // Note: User agent doesn't change, so we don't need event listeners
    // However, we keep this in an effect to ensure it runs client-side only
  }, [])

  return !!isMobile
}
